<template>
  <div v-show="activeTab">
    <slot name="default" />
  </div>
</template>
<script setup>
/*
    This component is used in 2 ways
     1. for tabs variant with dropdown menu (mobile) - it renders the content of the tab.
     2. for full-on tabs - it is used to access props of slotted content but DOES NOT render the content.
    Full-on tabs do not actually render it, it's all handled via TabsContent from Radix (in Tabs.vue)

    Example Usage:
    <Tab label="Tab 1" disabled badge="1">
      <div>Tab 1 content</div>
    </Tab>
 */
import { inject } from "vue";
const activeTab = inject("activeTab");

defineProps({
  id: { type: String, required: true },
  label: { type: String, required: false },
  disabled: { type: Boolean, required: false },
  loading: { type: Boolean, required: false },
  badge: { type: [String, Number], required: false },
});
</script>
